// Sooner (features/opening.md): what the page being opened waits for starts loading as soon as the app's
// scripts run (main.tsx), before React has drawn anything: who I am, and alongside it, not after it, the
// trip, my trips or the join link's trip. Each early load is taken once, by the first load that asks for it
// (App, TripPage, Trips, JoinPage); a later load (Try again, back online, a change) asks Tripmo again. The
// service worker answers these as it answers any other load (web/sw/sw.ts), so what the phone kept still
// shows without signal.

const started = new Map<string, Promise<unknown>>();

export function startEarly(key: string, load: () => Promise<unknown>) {
  const loaded = load();
  // Taken later, or never (the page shown turned out to be another): either way, not an unhandled rejection.
  loaded.catch(() => {});
  started.set(key, loaded);
}

// The early load for `key` if it's still waiting to be taken, else `load` now.
export function early<T>(key: string, load: () => Promise<T>): Promise<T> {
  const loaded = started.get(key) as Promise<T> | undefined;
  started.delete(key);
  return loaded ?? load();
}

// Who I am is in (or failed): the page shown has taken its early load by now (a page's effects run before
// App's), so any left were for a page not shown (getting started, a failure), and a later visit loads afresh.
export function forgetEarly() {
  started.clear();
}

export const tripKey = (trip: string) => `trip:${trip}`;
export const joinKey = (code: string) => `join:${code}`;
